/**
 * Échappe une chaîne pour une insertion sûre en contenu ou attribut HTML.
 * Fonction pure, sans dépendance DOM/Mapbox (revue finale du chantier
 * store-locator-revendeurs, F3 — 2026-09-24) : extraite dans son propre
 * fichier pour être partagée par `MapboxCluster.js`/`MapboxMarker.js` (leurs
 * infobulles injectaient jusque-là du texte magasin brut via `setHTML()`,
 * contenu ET attributs `alt`/`src`/`href`) et testable directement, sans
 * importer `mapbox-gl` (incompatible avec un test exécuté hors navigateur).
 * @param  {*} value
 * @returns {string}
 */
export default function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  })[char]);
}
